module.exports = __webpack_public_path__ + "static/media/item_22_1_comp.89f90bc1.png";